export default __webpack_public_path__ + "static/media/fr-asia-4.0545f495.jpg";